import React, { Component } from 'react'
import { utils_tool, component_tool } from "@/tool";
import columns from './columns'
const { WizModalForm,WizButton } = component_tool
export default class login extends Component {

    constructor(props){
        super(props)
        this.state = {
           visible: false, // 弹窗层状态
        }
    }

    componentDidMount() {
        const { messageEvent } = this.props
        messageEvent.on('login',() => {
            this.showModal()
        })
    }


    // 显示弹出表单
    showModal = () => {
        this.setState({
            visible: true
        });
    };

    // 隐藏弹出表单
    hideModal = () => {
        this.setState({
            visible: false
        });
    };

    submit = (value) => { 
        const { messageEvent } = this.props
        messageEvent.emit('loginResult',value)
        this.hideModal()
    }


    render() {
        const { visible } = this.state 
        const formProps = {
            title:'登录',
            visible,
            columns: columns(),
            onCancel: () => {
                this.hideModal() 
            },
            onSubmit: this.submit
        };
        return <WizModalForm {...formProps} />
    }
}
